import React from "react";
import BotLogo from "../../assets/logo/CTB_logo_Cropped.png"

const BotAvatar = () => {
  return (
    <div className="bot-avatar" style={{width: "35px", height: "35px"}}>
      <img
        src={BotLogo} // ✅ Change this to your bot image URL or local path
        alt="Bot"
        className="bot-avatar-img"
        width={"100%"}
      />
    </div>
  );
};

export default BotAvatar;